import ApplicationController from './application_controller';

/**
 * Shows the document type checkboxes only while the clinical documents sharing mode is "share_by_type".
 *
 * @controller clinical-document-types
 * @example please look at organizations/edit_partials/_emr_settings_body.html.erb.
 */
export default class extends ApplicationController {
  static targets = ['select', 'types'];

  static values = { mode: String };

  // The checkboxes render visible so they work without JavaScript. The saved mode decides the first
  // state, since the Impulse select may not have upgraded yet when this connects.
  connect() {
    this.show(this.modeValue);
  }

  toggle() {
    this.show(this.selectTarget.value);
  }

  show(mode) {
    this.typesTarget.hidden = mode !== 'share_by_type';
  }
}
